"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.barText = exports.barSection = exports.bar = exports.barContainer = exports.circularTypography = exports.circularCross = exports.circularTick = exports.circularRoot = exports.circularBottom = exports.circularTop = exports.linear = void 0;

var _react = require("@emotion/react");

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 11px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  width: calc((100% - (", " * 2px)) / ", ");\n  height: 4px;\n  transform: skewX(10deg);\n  margin-right: 2px;\n  background-color: ", ";\n\n  &:first-of-type,\n  &:last-of-type {\n    &::before {\n      position: absolute;\n      content: '';\n      height: inherit;\n      width: 10%;\n      background-color: inherit;\n      transform: skewX(-10deg);\n      transform-origin: bottom left;\n    }\n  }\n\n  &:first-of-type {\n    &::before {\n      left: -1px;\n    }\n  }\n\n  &:last-of-type {\n    &::before {\n      right: 0;\n    }\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 12px 0 0;\n  padding: 12px 0;\n  display: flex;\n  width: 80%;\n  align-items: center;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  height: 24px !important;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  height: 75%;\n  width: 12px;\n  fill: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  height: 75%;\n  width: 12px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  max-height: 16px;\n  max-width: 16px;\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  max-height: 16px;\n  max-width: 16px;\n  position: absolute;\n  left: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transform: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var linear = function linear(invert) {
  return (0, _react.css)(_templateObject(), invert ? 'rotate(180deg)' : undefined);
};

exports.linear = linear;
var circularTop = (0, _react.css)(_templateObject2());
exports.circularTop = circularTop;

var circularBottom = function circularBottom(theme) {
  return (0, _react.css)(_templateObject3(), theme.colors.neutral[300]);
};

exports.circularBottom = circularBottom;
var circularRoot = (0, _react.css)(_templateObject4());
exports.circularRoot = circularRoot;
var circularTick = (0, _react.css)(_templateObject5());
exports.circularTick = circularTick;

var circularCross = function circularCross(theme) {
  return (0, _react.css)(_templateObject6(), theme.colors.neutral[300]);
};

exports.circularCross = circularCross;
var circularTypography = (0, _react.css)(_templateObject7());
exports.circularTypography = circularTypography;
var barContainer = (0, _react.css)(_templateObject8());
exports.barContainer = barContainer;
var bar = (0, _react.css)(_templateObject9());
exports.bar = bar;

var barSection = function barSection(totalSteps, active) {
  return function (theme) {
    return (0, _react.css)(_templateObject10(), totalSteps, totalSteps, active ? theme.colors.primary.main : theme.colors.neutral[200]);
  };
};

exports.barSection = barSection;

var barText = function barText(theme) {
  return (0, _react.css)(_templateObject11(), theme.colors.neutral[600]);
};

exports.barText = barText;